export default "__VITE_ASSET__Kq1HlJ7c__"